import { SystemStyleObject } from '@chakra-ui/react';

interface StorageComponentSxType {
  root: SystemStyleObject;
  planWrapper: SystemStyleObject;
  widgetWrapper: SystemStyleObject;
  subscriptionButton: SystemStyleObject;
  planDetails: SystemStyleObject;
  progressBar: SystemStyleObject;
  storageLegend: SystemStyleObject;
}

export const storageComponentSx: StorageComponentSxType = {
  root: {
    position: 'relative',
    bg: 'M.20',
    py: 3,
    px: 4,
    borderRadius: 8,
    mt: 0,
    mb: { base: 9, md: 12 },
    flexDirection: { base: 'column', md: 'row' },
    alignItems: { base: 'flex-start', md: 'center' },
  },
  planWrapper: {
    height: 'full',
    flexDirection: 'column',
    mr: 8,
    mb: { base: '24px', md: 0 },
    mt: { base: '4px', md: 0 },
  },
  planDetails: {
    flexDirection: 'row',
    mt: 0.5,
    whiteSpace: 'nowrap',
  },
  widgetWrapper: {
    height: 'full',
    flexDirection: 'column',
    justifyContent: 'space-between',
    maxW: '358px',
    w: 'full',
  },
  subscriptionButton: {
    position: { base: 'absolute', md: 'relative' },
    top: { base: '16px', md: '0px' },
    right: { base: '16px', md: '0px' },
    ml: '56px',
  },
  progressBar: {
    width: 'full',
    borderRadius: 'full',
    bg: 'M.20',
    '[role="progressbar"]': {
      backgroundColor: 'M.20',
    },
    '&&': {
      marginTop: 1,
    },
  },
  storageLegend: {
    '&&': {
      marginTop: 0,
    },
  },
};
